import { render } from "./CheckoutReviews.vue?vue&type=template&id=7187d549"
import script from "./CheckoutReviews.vue?vue&type=script&lang=js"
export * from "./CheckoutReviews.vue?vue&type=script&lang=js"

import "./CheckoutReviews.vue?vue&type=style&index=0&id=7187d549&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__